import React, { useState } from 'react';

function RangeSlider({setTileSize}) {
  const [value, setValue] = useState(35); 

  const handleChange = (event) => {
    setValue(event.target.value);
    setTileSize(value*10)
  };


  return (
      <input 
        type="range"
        min="1"
        max="100"
        value={value}
        onChange={handleChange}
        className='flex-auto'
      />
  );
}

export default RangeSlider;
